import { REHYDRATE } from 'redux-persist';
import LoginState from './state';
import { LOGIN_INIT, LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_FAIL, LoginTypes } from './types';

const INITIAL_STATE = new LoginState();

export default function loginReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE: {
      if (action.payload != null && action.payload.loginState != null)
        return action.payload.loginState;
      return state;
    }

    case LOGIN_INIT:
      return { ...INITIAL_STATE, status: 'initialized' };

    case LOGIN_BEGIN:
      return {
        ...state,
        login: {
          loading: true,
          error: null,
        },
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: {
          loading: false,
          error: null,
        },
      };
    case LOGIN_FAIL:
      return {
        ...state,
        login: {
          loading: false,
          error: action.payload,
        },
      };

    // USER_UPDATE_PASSWORD
    case LoginTypes.USER_UPDATE_PASSWORD.LOADING:
      return {
        ...state,
        userUpdatePassword: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case LoginTypes.USER_UPDATE_PASSWORD.SUCCESS:
      return {
        ...state,
        userUpdatePassword: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case LoginTypes.USER_UPDATE_PASSWORD.ERROR:
      return {
        ...state,
        userUpdatePassword: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

     // USER_GET_LINKEDIN_INFO
    case LoginTypes.USER_GET_LINKEDIN_INFO.LOADING:
      return {
        ...state,
        userLinkedinInfo: {
          ...INITIAL_STATE.userLinkedinInfo,
          loading: true,
        },
      };
    case LoginTypes.USER_GET_LINKEDIN_INFO.SUCCESS:
      return {
        ...state,
        userLinkedinInfo: {
          ...INITIAL_STATE.userLinkedinInfo,
          data: action.payload,
        },
      };
    case LoginTypes.USER_GET_LINKEDIN_INFO.ERROR:
      return {
        ...state,
        userLinkedinInfo: {
          ...INITIAL_STATE.userLinkedinInfo,
          error: action.payload,
        },
      };

    default:
      return state;
  }
}
